export default __webpack_public_path__ + "f3ece54585af02aa5139cb4975218500.png";